import {
  NOTIFICATION,
  NOTIFICATION_SUCCESSFUL,
  NOTIFICATION_FAILED,
  UPDATE_NOTIFICATION,
  UPDATE_NOTIFICATION_SUCCESSFUL,
  UPDATE_NOTIFICATION_FAILED
} from "./actionTypes"

const initialState = {
  notifications: [],
  errorMessage: "",
  successMessage: "",
  loading: false
}

const getNotificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case NOTIFICATION:
      state = {
        ...state,
        loading: true,
        notifications: [],
        errorMessage: "",
        successMessage: ""
      }
      break
    case NOTIFICATION_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        notifications: action.payload
      }
      break
    case NOTIFICATION_FAILED:
      state = {
        ...state,
        loading: false,
        errorMessage: action.payload,
      }
      break
    case UPDATE_NOTIFICATION:
      state = {
        ...state,
        loading: true,
      }
      break
    case UPDATE_NOTIFICATION_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        successMessage: action.payload,
      }
      break
    case UPDATE_NOTIFICATION_FAILED:
      state = {
        ...state,
        loading: false,
        errorMessage: action.payload,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default getNotificationReducer
